module.exports = __webpack_public_path__ + "static/media/AC04003W.8322cf5d.png";